module.exports = __webpack_public_path__ + "img/tab_close.023fc927.svg";